import { render, staticRenderFns } from "./order-status.vue?vue&type=template&id=37a8cbb5&scoped=true"
import script from "./order-status.vue?vue&type=script&lang=js"
export * from "./order-status.vue?vue&type=script&lang=js"
import style0 from "./order-status.vue?vue&type=style&index=0&id=37a8cbb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a8cbb5",
  null
  
)

export default component.exports